import { connect } from 'react-redux';
import { uniq, isArray } from 'lodash';

const stateToProps = (state) => {
  const {
    session: {
      affiliate: {
        attributes: {
          config: affiliateConfig,
        },
      },
      isSuperUser,
      permissions: {
        permissionGroups,
      },
    },
  } = state;

  const permissions = uniq(permissionGroups.reduce(
    (allPermissions, { attributes: { permissions: groupPermissions } }) => allPermissions.concat(groupPermissions),
    []));

  const hasConfigEnabled = configKey => affiliateConfig[configKey] === 'true';

  const hasPermissions = (requiredPermissions, ...rest) => {
    if (isSuperUser) {
      return true;
    }

    const required = (isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions]).concat(rest);

    return required
      .map(permission => permissions.indexOf(permission) !== -1)
      .reduce((all, next) => (all && next));
  };

  const hasConfigAndPermissions = (configKey, requiredPermissions, ...rest) =>
    hasConfigEnabled(configKey) && hasPermissions(requiredPermissions, ...rest);

  return {
    hasConfigEnabled,
    hasPermissions,
    hasConfigAndPermissions,
  };
};

const compose = Component =>
  connect(stateToProps)(Component);

export default compose;



// WEBPACK FOOTER //
// ./src/utils/with-affiliate-config.js